import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string, prop?: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    if(prop){
      return items.filter(item => String(item[prop]).toLowerCase().includes(searchText.toLowerCase()));
    }
    return items.filter(item => String(item).toLowerCase().includes(searchText.toLowerCase()));
  }
}
